<script setup>
import { useNewsStore } from '@stores/news'
import { ref } from 'vue'

import ArticleCard from '@components/global/article-card.vue'
import Button from '@components/global/button.vue'

const news = useNewsStore()
const selected = ref(null)
</script>
<template>
	<section class="container">
		<div class="flex w-full flex-col justify-center gap-4 md:flex-row">
			<Button :class="news.filter == null ? 'secondary' : 'outlined'" @click="news.setFilter(null)" label="All" />
			<Button v-for="category in news.categories" :class="news.filter === category.slug ? 'secondary' : 'outlined'" @click="news.setFilter(category.slug)" :label="category.name" />
		</div>
	</section>
	<section class="container">
		<div class="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
			<ArticleCard v-for="item in news.filtered" :item="item" type="main" />
		</div>
	</section>
	<!-- <section class="container flex justify-center">
		<Button class="outlined w-fit" label="Load more articles" />
	</section> -->
</template>
